import { ReactNode, createContext, useContext } from "react";
import { useDateTime } from "./date-time.hook";

const DateTimeContext = createContext({} as ReturnType<typeof useDateTime>);
export function useDateTimeContext() {
  return useContext(DateTimeContext);
}

interface DateTimeProviderProps {
  children: ReactNode;
  dateFormat?: string;
  dateTimeFormat?: string;
  timeFormat?: string;
}
export function DateTimeProvider({
  children,
  dateFormat,
  dateTimeFormat,
  timeFormat
}: DateTimeProviderProps) {
  return (
    <DateTimeContext.Provider
      value={useDateTime({ dateFormat, dateTimeFormat, timeFormat })}
    >
      {children}
    </DateTimeContext.Provider>
  );
}
